import { TilesService } from '../services/tiles.service';
import { retry } from 'rxjs/operators';

export function userInitializer(tilesService: TilesService): any {
  return () => {
    return new Promise(async (resolve) => {
      await tilesService.fetchWallTiles().pipe(retry(5)).toPromise();
      if (!!localStorage.getItem('token')) {
        await tilesService.fetchCartItems().toPromise();
      }
      resolve(true);
    });
  };
}
